import {Messages} from "../constants/messages";

export function getMessage(key) {
  if (Messages[key]) {
    return Messages[key];
  }
  return key;
}
